import type { TextProps } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';
import React from 'react';

interface FilterButtonLabelProps extends TextProps {
  children: React.ReactNode;
}

export const FilterButtonLabel: React.FC<FilterButtonLabelProps> = ({ children, ...textProps }) => {
  return (
    <Text as="span" fontWeight="semibold" mr={1} {...textProps}>
      {children}
    </Text>
  );
};
